// extracted by mini-css-extract-plugin
export default {"ClipboardCopy":"ClipboardCopy_ClipboardCopy__WknKu","hintVisible":"ClipboardCopy_hintVisible__+P9nU","hint":"ClipboardCopy_hint__daOq7"};